import * as changeKeys from 'change-case/keys'
import type { DesignProject } from '~~/layers/base/types/designProject'

export const useBuilderSessionService = () => {
    const runtimeConfig = useRuntimeConfig() as {
        public?: {
            assetNodeslsUrl?: string
            imagelibApiUrl?: string
            appEnvId?: string
            /** ACCS ecommerce id — build-baked `appEcommerceId` in `nuxt.config`. */
            appEcommerceId?: string
        }
    }
    const assetNodeslsUrl = runtimeConfig.public?.assetNodeslsUrl
    const fingerprintId = useFingerprint().$fingerprintId
    const customerStore = useCustomerStore()

    const { customer } = storeToRefs(customerStore)

    const convertDesignerToLegacy = async (designerProject: DesignProject) => {
        let userData = {}
        if (customer?.value?.id) {
            userData = {
                customerId: customer.value.id,
                customerName: `${customer.value?.firstName} ${customer.value.lastName}`,
                fingerprintId: fingerprintId,
            }
        } else {
            userData = {
                guestName: 'Guest',
                guestId: fingerprintId,
                fingerprintId: fingerprintId,
            }
        }

        const url = `${assetNodeslsUrl}/sync-design-project-to-builder-session`
        const designProjectPayload = changeKeys.snakeCase(designerProject, 99)
        const pending = ref(true)
        const error = ref<unknown | null>(null)
        const data = ref<unknown | null>(null)
        try {
            data.value = await $fetch(url, {
                method: 'POST',
                body: {
                    design_project: designProjectPayload,
                    extra_property: {
                        user_data: changeKeys.snakeCase(userData),
                        env_id: runtimeConfig.public?.appEnvId,
                        imagelib_api_url: runtimeConfig.public?.imagelibApiUrl,
                        ecommerce_id: runtimeConfig.public?.appEcommerceId,
                    },
                },
            })
        } catch (err) {
            error.value = err
        } finally {
            pending.value = false
        }
        return { data, error, pending }
    }

    return {
        convertDesignerToLegacy,
    }
}
